import { httpGet, httpPost } from 'src/utils/http';
import { CheckCustomerTypeResponse } from 'src/models/CustomerTypeSecurity/checkCustomerType';

const getPath = (path: string) => `/customerTypeSecurity/${path}`;

export const apiCheckCustomerType = (): Promise<CheckCustomerTypeResponse> => httpGet(getPath('CheckCustomerType'));

export const apiSetPersonalOrBusinessForBusinessModalShown = () =>
  httpPost(getPath('SetPersonalOrBusinessForBusinessModalShown'));
